import { Request, RequestStatus } from "@/types/request";
import { Task } from "@/types/tasks";

export const getRequestWorkflowStatus = (request: Request): RequestStatus => {
  const task = request.tasks?.[0];
  if (task) {
    return task.status;
  }
  if (request.status) {
    return request.status;
  }
  return RequestStatus.NEW_TASK;
};

export const getTaskAssignment = (
  task?: Task,
  service?: Request["service"],
) => {
  const assignedTeamId =
    task?.teamStaffId ||
    task?.team?.id ||
    service?.team?.id ||
    service?.teamId ||
    undefined;
  const assignedTeamName = task?.team?.name || service?.team?.name;

  let assignedStaffId: string | undefined;
  let assignedStaffName: string | undefined;

  if (!assignedTeamId) {
    assignedStaffId =
      task?.staffId ||
      task?.staff?.id ||
      service?.staff?.id ||
      service?.staffId ||
      undefined;
  }

  const staff = task?.staff || service?.staff;
  if (staff) {
    assignedStaffName =
      `${staff.profile?.firstName || ""} ${staff.profile?.lastName || ""}`?.trim() ||
      undefined;
  }

  return {
    assignedTeamId,
    assignedTeamName,
    assignedStaffId,
    assignedStaffName,
  };
};
